export function VProps (state: any) {
  return ({
    name: state.path,
    error: state.errors[0],
  })
}
